import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController } from '@ionic/angular';
import { CommitteeMember } from 'src/app/models/CommitteeMember';
import { Employee } from 'src/app/models/Employees';
import { AuthService } from 'src/app/services/auth.service';
import { CommitteeService } from 'src/app/services/modelService/committee.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { ParamService } from 'src/app/services/param.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-committee-member-list',
  templateUrl: './committee-member-list.component.html',
  styleUrls: ['./committee-member-list.component.scss'],
})
export class CommitteeMemberListComponent implements OnInit {
  @Input() type: string;

  displayEmployee: Employee;
  displayProfile: boolean = false;
  constructor(public cs: CommitteeService, private auth: AuthService, private router: Router,
    private actionSheetController: ActionSheetController, private whatsapp: WhatsappService, private toast: ToastService,
    private alert: AlertService, private paramService: ParamService, private empService: EmployeeSService) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.getMembers();
  }

  getMembers() {
    console.log(this.type);
    if (this.type == 'Posts') {
      this.cs.getMemberList([["committee_id", this.cs.committee.id], ['role', null, '!=']])
    } else {
      this.cs.getMemberList([["committee_id", this.cs.committee.id]])
    }

  }

  onClickJoinMember() {
    this.alert.showAlert("Join Committee", "Are you sure you want to join this committee?", "Join").then(() => {
      this.cs.addCommitteeMember().then((response: CommitteeMember) => {
        if (response) {
          this.cs.myMemberShip = response;
          this.cs.sendReminder();
        }
      });
    })
  }

  async clickMember(member: CommitteeMember) {
    console.log(this.auth.loggedInEmployee);
    let buttonList = [
      // {
      //   text: 'View Details',
      //   icon: 'eye',
      //   handler: () => {
      //     this.empService.getEmpByVariable('id', member.emp_id).then((emp: any) => {
      //       this.displayEmployee = emp;
      //       this.displayProfile = true;
      //     })
      //   }
      // },
      {
        text: 'View Vansh',
        icon: 'snow',
        handler: () => {
          this.empService.getEmpByVariable('id', member.emp_id).then((emp: any) => {

            this.paramService.setData("empFromList", emp)
            this.router.navigate(['/vansh/family-tree'], { replaceUrl: true });
          });
        }
      }]
    if (this.cs.myMemberShip?.role == 'Admin') {
      buttonList.push(
        {
          text: 'Assign Role',
          icon: 'ribbon',
          handler: () => {
            this.assignRole(member)
          }
        }, {
        text: 'Remove Role',
        icon: 'ribbon-outline',
        handler: () => {
          this.checkForAdmin(member, null);
        }
      })
    }
    buttonList.push({
      text: 'Cancel',
      icon: 'close',
      handler: () => {
        console.log('Cancel clicked');
      }
    });

    const actionSheet = await this.actionSheetController.create({
      header: 'Member options : ' + member.profile_meta.name,
      buttons: buttonList
    });

    await actionSheet.present();
  }

  async assignRole(member) {
    const roleList = ['Admin', 'President', 'Vice President', 'Secretary', 'Treasurer', 'BLO', 'Custom'];
    let buttonList = [];
    for (let role of roleList) {
      buttonList.push({
        text: role,
        handler: () => {
          if (role === 'Custom') {
            this.alert.showTextAlert('Custom Role', 'Enter the custom role for ' + member.profile_meta.name, 'Role Name').then((customRole) => {
              if (customRole && customRole.trim().length > 0) {
                this.checkForAdmin(member, customRole.trim());
              }
            });
          } else {
            this.checkForAdmin(member, role);
          }
        }
      })
    }

    buttonList.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    })

    const actionSheet = await this.actionSheetController.create({
      header: 'Assign Role to ' + member.profile_meta.name + ' Ji',
      buttons: buttonList
    });

    await actionSheet.present();
  }

  setRole(member, role) {
    member.role = role;
    this.cs.saveCommitteeMember(member).then(() => {
      this.toast.success("Role updated successfully");
    })
  }

  checkForAdmin(member, role) {
    if (member.role == 'Admin') {
      this.cs.getMemberList([["committee_id", this.cs.committee.id], ["role", "Admin"]], false).then((members: CommitteeMember[]) => {
        if (members.length > 1) {
          this.setRole(member, role);
        } else {
          this.toast.warning('At least one admin is required');
        }
      })
    } else {
      this.setRole(member, role);
    }
  }


  getStatusColor(member) {
    switch (member.status) {
      case 'Pending':
        return 'warning';
      case 'Rejected':
        return 'danger';
      default:
        return 'primary';
    }
  }

  clickApproval(member) {
    if (this.cs.myMemberShip?.role != null) {
      this.alert.showAlert("Verify " + member.profile_meta.name + " Ji", "Are you sure you want to Verify this member?", "Verify").then(() => {
        member.status = "Verified";
        this.cs.saveCommitteeMember(member).then(() => {
          this.toast.success("Member verified` successfully");
        })
      })
    } else {
      this.toast.warning('Only Post members can verify request');
    }
  }

}
